import { render, staticRenderFns } from "./OperationsSummary.vue?vue&type=template&id=0034976e&scoped=true"
import script from "./OperationsSummary.vue?vue&type=script&lang=js"
export * from "./OperationsSummary.vue?vue&type=script&lang=js"
import style0 from "./OperationsSummary.vue?vue&type=style&index=0&id=0034976e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0034976e",
  null
  
)

export default component.exports